export default [
    {
        path: "/empresa/general",
        name: "empresaGeneral",
        component: () =>
            import(
          /* webpackChunkName: "empresaGeneralView" */ "./views/empresaGeneralView.vue"
            ),
    },
];